import Axios from 'axios'

export default {
  loadGames (Vue, refresh) {
    if (!refresh) Vue.$data.gamesLoading = true
    Axios.get(`${Vue.$apiUrl}/games-list`).then((res) => {
      if (res.data) {
        Vue.$data.gamesLoading = false
        Vue.$data.tours = res.data.tours
        if (!refresh) {
          res.data.tours.forEach((tour) => {
            if (tour.isMain) Vue.$data.activeTour = `tab-${tour._id}`
          })
        }
        if (res.data.predicts) {
          let points = 0
          let eMoney = 0
          Object.keys(res.data.predicts).map((key, index) => {
            points += res.data.predicts[key].points
            eMoney += res.data.predicts[key].eMoney
            Vue.$data.predicts[key] = res.data.predicts[key]
          })
          Vue.$store.commit('var', { type: 'userData', i: 'points', v: points })
          Vue.$store.commit('var', { type: 'userData', i: 'eMoney', v: eMoney })
        }
      }
    }).catch((err) => {
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    }).then(() => {
      Vue.$data.gamesLoading = false
    })
  },
  saveScore (Vue, obj) {
    if (!Vue.$data.predicts[obj.gameId]) {
      Vue.$data.predicts[obj.gameId] = {}
      Vue.$data.predicts[obj.gameId][obj.country] = obj.score
    } else {
      Vue.$data.predicts[obj.gameId][obj.country] = obj.score
      let tempData = Vue.$data.predicts[obj.gameId]
      if ((tempData.firstScore >= 0 && obj.country === 'secondScore') ||
        (tempData.secondScore >= 0 && obj.country === 'firstScore')) {
        let sendData = {
          gameId: obj.gameId,
          data: Vue.$data.predicts[obj.gameId]
        }
        Axios.post(`${Vue.$apiUrl}/saveScore`, sendData).then((res) => {
        }).catch((err) => {
          Vue.$notice['error']({
            title: err.response.statusText,
            description: err.response.data
          })
        })
      } else {
        Vue.$data.predicts[obj.gameId][obj.country] = obj.score
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ResultsPredict/index.js